import { FC, ChangeEvent, useState, useEffect } from 'react';
import {
  Modal, Tooltip, Button, Divider, Box, FormControl, InputLabel, Card, Checkbox, IconButton, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TableContainer, Select, MenuItem, Typography, useTheme, CardHeader, CircularProgress,
  Container
} from '@mui/material';
import axios from 'axios';
import { CryptoOrder, CryptoOrderStatus } from 'src/models/crypto_order';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import './notificationListing.css';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';



const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 480,
  bgcolor: 'transparent',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
interface CategoryListTableProps {
  className?: string;
}

interface Filters {
  status?: CryptoOrderStatus;
}


const applyFilters = (
  cryptoOrders: any[],
  filters: Filters
): CryptoOrder[] => {
  return cryptoOrders.filter((cryptoOrder) => {
    let matches = true;
    return matches;
  });
};

const applyPagination = (
  cryptoOrders: CryptoOrder[],
  page: number,
  limit: number
): CryptoOrder[] => {
  return cryptoOrders.slice(page * limit, page * limit + limit);
};

const CategoryListTable: FC<CategoryListTableProps> = ({ }) => {
  const [clickedID, setClickedID] = useState(null)

  const [open, setOpen] = useState(false);
  const handleOpen = (id) => {
    setOpen(true);
    setClickedID(id)
  }

  const columns = [
    // { field: 'Type', headerName: 'User Type', width: 170 },
    { field: 'Title', headerName: 'Title', width: 450 },
    { field: 'Type', headerName: 'Type', width: 340 },
    


    // { field: 'Content', headerName: 'Content', width: 300 },
    {
      field: 'Content',
      headerName: 'Content',
      width: 500,
      renderCell: (params) => {
        return (
          <div
            dangerouslySetInnerHTML={{ __html: params.row.Content }}
          />
        );
      },
    },
    {
      field: 'description',
      headerName: 'description',
      width: 500,
      renderCell: (params) => {
        return (
          <div
            dangerouslySetInnerHTML={{ __html: params.row.Description }}
          />
        );
      },
    },
    {
      field: 'Actions',
      headerName: 'Actions',
      sortable: false,
      filterable: false,
  
      disableClickEventBubbling: true,
      renderCell: (params) => {
        return (
          <>
            <Tooltip title="Edit Announcement" arrow>
              <IconButton
                sx={{
                  '&:hover': {
                    background: theme.colors.primary.lighter
                  },
                  color: theme.palette.primary.main
                }}
                color="inherit"
                size="small"
              >
                <EditTwoToneIcon fontSize="small"
                  onClick={() => navigate(`/notifications/edit-notification/${params?.row._id}
                  `)}
                />
              </IconButton>
            </Tooltip>

            <Tooltip title="Delete Announcement " arrow>
              <IconButton
                sx={{
                  '&:hover': {
                    background: theme.colors.primary.lighter
                  },
                  color: theme.palette.primary.main
                }}
                color="inherit"
                size="small"
              >
                <DeleteTwoToneIcon fontSize='small'
                  onClick={() => handleOpen(params.row._id)}
                  className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
                />
              </IconButton>
            </Tooltip>

          </>
        );
      },
    },
  ];

  const handleClose = () => {
    setOpen(false);
    setClickedID(null)
  }
  const [Loading, setLoading] = useState(false)
  const [cryptoOrders, setcryptoOrdersPage] = useState([]);
  const [selectedCryptoOrders, setSelectedCryptoOrders] = useState([]);
  const selectedBulkActions = selectedCryptoOrders.length > 0;
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(5);
  const [filters, setFilters] = useState<Filters>({
    status: null
  });

  const filteredCryptoOrders = applyFilters(cryptoOrders, filters);
  const paginatedCryptoOrders = applyPagination(
    filteredCryptoOrders,
    page,
    limit
  );
  const selectedSomeCryptoOrders =
    selectedCryptoOrders.length > 0 &&
    selectedCryptoOrders.length < cryptoOrders.length;
  const selectedAllCryptoOrders =
    selectedCryptoOrders.length === cryptoOrders.length;
  const theme = useTheme();
  const navigate = useNavigate();

  const fetchNotificationData = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/notifications/getAllNotification?type=all`);
      console.log(response,"ggggggg");
      
      if (response?.data) {
        setLoading(false)
        const d = response?.data
        const sortedCrypto = d.sort((a: any, b) => {
          return +new Date(b.createdAt) - +new Date(a.createdAt);
        });
        setcryptoOrdersPage(sortedCrypto)
      }
    } catch (err) {
      toast.error(err?.response?.data?.message, { position: "bottom-right" });
    }
  };

  useEffect(() => {
    fetchNotificationData();
  }, []);

  const [deleteButton, setDeleteButton] = useState(false)
  const handleDeleteData = async (id: any) => {
    try {
      setDeleteButton(true)
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/notifications/deletenotification/${id}`);
      toast.success('Announcement Deleted Successfully!', { position: "bottom-right" });
      setDeleteButton(false)
      fetchNotificationData();
      handleClose();
    } catch (error) {
      setDeleteButton(false)

      toast.error(error?.response?.data?.message, { position: "bottom-right" });
    }
  }

  const handleDeleteUsers = async () => {
    try {
      setDeleteButton(true);
      for (const id of selectedCryptoOrders) {
        await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/notifications/deletenotification/${id}`);
      }
      setDeleteButton(false);
      toast.success('Selected Notification Deleted Successfully!', { position: "bottom-right" });
      setSelectedCryptoOrders([]);
      fetchNotificationData();
    } catch (error) {
      setDeleteButton(false);
      toast.error(error?.response?.data?.message, { position: "bottom-right" });
    }
  };


  return (

    <>
    
    
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h3" component="h2">
            Are you sure to delete?
          </Typography>
          <hr />


          <Button type="submit" sx={{ mt: 2, mr: 2 }} variant="contained" onClick={() => handleDeleteData(clickedID)}
            disabled={deleteButton}
          >
            Yes
          </Button>

          <Button type="submit" sx={{ mt: 2 }} variant="contained" onClick={() => handleClose()}>
            Cancel
          </Button>

        </Box>
      </Modal>
      

     


      <Container maxWidth="lg">
        <Card>

      <Box className="innerr_box" sx={{ p: 3, width: "auto" }}>
        <Divider variant="middle" />
        <div className="table">
          <DataGrid
            rows={cryptoOrders}
            // disableColumnFilter
            getRowId={(row) => row._id}
            columns={columns}
            className="mybonustable widthtable"
            slots={{ toolbar: GridToolbar }}
            onRowSelectionModelChange={(newSelection) => {
              // console.log("newSelection ", newSelection);
              setSelectedCryptoOrders(newSelection);
            }}
            checkboxSelection
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 }
              }
            }}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterValues: ['']
                }
              },
              pagination: {
                paginationModel: { pageSize: 10, page: 0 }
              }
            }}
          />
        </div>
        {/* <Button variant="contained" color="warning" onClick={handleDeleteUsers}
          disabled={selectedCryptoOrders.length === 0 || deleteButton}>
          Delete Notifications
        </Button> */}

        <Button
          variant="contained"
          color="warning"
          onClick={handleDeleteUsers}
          disabled={selectedCryptoOrders.length === 0 || deleteButton}
          style={{ display: selectedCryptoOrders.length === 0 || deleteButton ? 'none' : 'block' }}
        >
          Delete Notifications
        </Button>


      </Box>
      </Card>
      </Container>

    </>



  );
};

export default CategoryListTable;
